import { CheckCircle, CircleQuestion } from 'assets/icons/Icons';
import { Badge } from 'screens/Messages/components/Badge/Badge';
import styled from 'styled-components';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75em;
`;

export const ListHeader = styled.div`
  display: grid;
  align-items: center;
  grid-template-columns: 1.5fr 1fr 1fr auto;
  gap: 1em;

  @media ${({ theme }) => theme.queries.maxTablet} {
    grid-template-columns: 1.5fr 1fr 1fr;
  }
`;

export const ListItem = styled.div<{
  highlightTodaysListItems?: boolean;
}>`
  display: grid;
  align-items: center;
  grid-template-columns: 1.5fr 1fr 1fr auto;
  gap: 1em;
  border-radius: 0.5em;
  background: ${({ highlightTodaysListItems, theme }) =>
    highlightTodaysListItems
      ? `radial-gradient(50% 50% at 50% 0%, rgba(255, 255, 255, 0.48) 0%, rgba(255, 255, 255, 0.00) 100%), ${theme.colors.yellow.lightestYellow}`
      : theme.colors.white};
  box-shadow: ${({ highlightTodaysListItems, theme }) =>
    highlightTodaysListItems ? theme.shadows.container.glowYellow : theme.shadows.card.level0};
  min-height: 72px;
  padding: 0.8em 1.5em;

  @media ${({ theme }) => theme.queries.maxTablet} {
    gap: 1em;
  }
`;

export const ListItemInfo = styled.div`
  display: grid;
  grid-template-columns: 1.5em 1fr;
  grid-auto-rows: auto;
  column-gap: 0.5em;
  row-gap: 0.25em;
  flex-direction: column;
  align-items: center;

  svg {
    justify-self: center;
    color: ${({ theme }) => theme.colors.neutral.lighterNavy};
  }
`;

export const HeaderMobile = styled.div`
  display: flex;
  gap: 0.75em;
  align-items: center;
`;

export const LisItemMobile = styled.div<{
  highlightTodaysListItems?: boolean;
}>`
  border-radius: 8px;
  background: ${({ highlightTodaysListItems, theme }) =>
    highlightTodaysListItems
      ? `radial-gradient(50% 50% at 50% 0%, rgba(255, 255, 255, 0.48) 0%, rgba(255, 255, 255, 0.00) 100%), ${theme.colors.yellow.lightestYellow}`
      : theme.colors.white};
  box-shadow: ${({ highlightTodaysListItems, theme }) =>
    highlightTodaysListItems ? theme.shadows.container.glowYellow : theme.shadows.card.level0};
  padding: 0.75em 1em;
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 0.75em;
`;

export const DateAndTime = styled.div`
  display: flex;
  gap: 1em;
`;

export const Date = styled.div`
  display: flex;
  gap: 0.5em;

  svg {
    color: ${({ theme }) => theme.colors.neutral.lighterNavy};
  }
`;

export const Time = styled.div`
  display: flex;
  gap: 0.25em;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.colors.neutral.lighterNavy};
  }
`;

export const LocationMobile = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25em;
`;

export const LocationMobileHeader = styled.div`
  display: flex;
  gap: 0.5em;
  align-items: center;

  svg {
    color: ${({ theme }) => theme.colors.neutral.lighterNavy};
  }
`;

export const CheckIcon = styled(CheckCircle).attrs({ type: 'solid' })`
  color: ${({ theme }) => theme.colors.green.darkGreen};
  margin-right: 0.5em;
`;

export const QuestionIcon = styled(CircleQuestion).attrs({ type: 'solid' })`
  color: ${({ theme }) => theme.colors.neutral.lighterNavy};
  margin-right: 0.5em;
`;

export const TodaysBadge = styled(Badge)`
  background-color: ${({ theme }) => theme.colors.yellow.primary};
  position: absolute;
  top: -10px;
  right: -12px;
  transform: rotate(5deg);
  transform-origin: top right;
  z-index: 1;

  @media ${({ theme }) => theme.queries.minDesktop} {
    display: inline-flex;
    position: static;
    top: auto;
    right: auto;
    transform: none;
    transform-origin: initial;
    margin-right: 0.5em;
  }
`;

export const Disclaimer = styled.p`
  ${({ theme }) => theme.fontSizes['14']};
  color: ${({ theme }) => theme.colors.neutral.primaryNavy};
  margin: 0.5em 0 0 0;
  line-height: 1.4;
`;

export const ActionsContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 0.75em;
  justify-content: flex-end;

  @media ${({ theme }) => theme.queries.maxTablet} {
    width: 100%;

    > button {
      flex: 1;
    }
  }
`;

export const OverflowMenuButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 48px;
  min-height: 48px;
  padding: 16px;
  border: none;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: ${({ theme }) => theme.shadows.button.default};
  cursor: pointer;

  svg {
    color: ${({ theme }) => theme.colors.neutral.primaryNavy};
    width: 16px;
    height: 16px;
  }

  &:hover {
    background:
      linear-gradient(0deg, rgba(247, 247, 253, 0.5) 0%, rgba(247, 247, 253, 0.5) 100%),
      ${({ theme }) => theme.colors.white};
    box-shadow: ${({ theme }) => theme.shadows.button.hover};
  }

  &:active {
    box-shadow: ${({ theme }) => theme.shadows.button.activeSecondary};
  }
`;

export const overflowMenuClassName = 'overflow-menu-dropdown';

export const OverflowMenuStyles = styled.div`
  .${overflowMenuClassName} {
    border: none;
    border-radius: 16px;
    box-shadow: ${({ theme }) => theme.shadows.card.level1};
    padding: 8px;
    min-width: 200px;
    z-index: ${({ theme }) => theme.layers.footer + 1};
    top: auto;
    bottom: 100%;
    right: auto;
    margin-bottom: 8px;
  }
`;
